export const PAYMENT_HOST_CODES = Object.freeze({
	UNINITIALIZED: 0,
	COMDATA: 1,
	TCH: 2,
	EFS: 4,
	TCHECK: 8,
	WORLDPAY: 16,
	RELAY: 32,
	JPM: 64,
});

export const PAYMENT_TYPE_CODES = Object.freeze({
	PT_NOT_FOUND: 0,
	PT_COMDATA_CHECK: 1,
	PT_COMDATA_CARD: 2,
	PT_EFS_CHECK: 4,
	PT_EFS_CARD: 8,
	PT_TCH_CHECK: 16,
	PT_TCH_CARD: 32,
	PT_TCHECK_CARD: 64,
	PT_TCHECK_CHECK: 128,
	PT_WP_VISA: 256,
	PT_WP_MASTERCARD: 512,
	PT_WP_DISCOVER: 1024,
	PT_WP_AMEX: 2048,
	PT_RELAY: 4096,
	PT_JPM_AMEX: 8000,
	PT_JPM_CHASE_NET: 8001,
	PT_JPM_DINERS_CLUB: 8002,
	PT_JPM_DISCOVER: 8003,
	PT_JPM_JCB: 8004,
	PT_JPM_MC: 8005,
	PT_JPM_UNION_PAY: 8006,
	PT_JPM_US_PINLESS: 8007,
	PT_JPM_VISA: 8008,
	PT_JPM_VISA_RESTRICTED_DEBIT: 8009,
	PT_JPM_UNKNOWN_CARD: 8010,
});

export const TRANSACTION_STATUS_CODES = Object.freeze({
	UNINITIALIZED: 0,
	CREATED: 1,
	DECLINED: 2,
	CANCELED: 4,
	AUTHORIZED: 8,
	PRE_AUTHORIZED: 16,
	PRE_EDITED: 32,
	PROMPTING_USER: 64,
	MANUALLY_AUTHORIZED: 128,
	USERCANCELED: 256,
});

export const RESOLVED_TRANSACTION_STATUS_CODES = Object.freeze([
	TRANSACTION_STATUS_CODES.AUTHORIZED,
	TRANSACTION_STATUS_CODES.MANUALLY_AUTHORIZED,
	TRANSACTION_STATUS_CODES.CANCELED,
	TRANSACTION_STATUS_CODES.USERCANCELED,
]);
